import React from 'react';
import {RoutePermittedRole} from '@crema/constants/AppEnums';
import Account from '../../../modules/account/MyProfile';

export const accountPagesConfigs = [
  {
    permittedRole: RoutePermittedRole.ROLE_XSUB_DEFAULT,
    path: '/my-profile',
    element: <Account />,
  },
];
